'use client';

import { useEffect } from 'react';
import { initBrowserMonitoring } from 'services/browserMonitoring.service';

/**
 * Starts the New Relic browser agent on mount.
 *
 * The agent only injects distributed tracing headers onto fetch/XHR it has
 * wrapped, so it has to start before the page makes its API calls rather than
 * lazily on the first `log()` (SR-420).
 */
export default function BrowserMonitoringInitializer() {
  useEffect(() => {
    void initBrowserMonitoring();
  }, []);

  return null;
}
